import IconWrapper from "@components/svg_icon_wrapper"

export default function ConversationCardWhatsappBusinessIcon() {
  return (
    <IconWrapper sx={{ width: 13, height: 13 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 2500 2500"
      >
        <defs>
          <linearGradient
            id="linear-gradient"
            x1={2335.52}
            x2={2335.52}
            y1={6714.92}
            y2={-6385.98}
            gradientTransform="matrix(.19 0 0 -.19 804.32 1281.38)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#61fd7d" />
            <stop offset={1} stopColor="#2bb826" />
          </linearGradient>
          <style>{".cls-2{fill-rule:evenodd;fill:#fff}"}</style>
        </defs>
        <title>{"whatsapp-business"}</title>
        <path
          d="M2499.8 1865.58c0 13.69-.42 43.37-1.24 66.3-2 56.11-6.46 128.51-13.19 161.5-10.11 49.57-25.37 96.36-45.26 135.31A481.8 481.8 0 0 1 2228 2440.54c-39.15 19.95-86.23 35.22-136.09 45.29-32.66 6.59-104.51 11-160.26 12.94-23 .82-52.65 1.23-66.28 1.23l-1231-.2c-13.69 0-43.37-.42-66.3-1.24-56.11-2-128.51-6.46-161.5-13.18-49.57-10.12-96.37-25.37-135.31-45.27A481.67 481.67 0 0 1 59.46 2228c-20-39.15-35.23-86.23-45.29-136.08-6.59-32.66-11-104.52-12.94-160.27C.41 1908.72 0 1879 0 1865.39l.2-1231c0-13.69.42-43.37 1.24-66.3 2-56.11 6.46-128.51 13.18-161.5C24.73 357.05 40 310.26 59.89 271.31A481.8 481.8 0 0 1 272 59.45c39.16-20 86.24-35.22 136.1-45.28 32.65-6.6 104.51-11 160.26-12.94C591.28.41 621 0 634.61 0l1231 .2c13.69 0 43.37.42 66.3 1.24 56.11 2 128.51 6.46 161.5 13.18C2143 24.73 2189.74 40 2228.69 59.89A481.67 481.67 0 0 1 2440.54 272c20 39.15 35.22 86.23 45.29 136.08 6.59 32.66 11 104.52 12.94 160.27.82 22.95 1.23 52.65 1.23 66.28Z"
          style={{
            fill: "url(#linear-gradient)",
            fillRule: "evenodd"
          }}
        />
        <path
          d="M1912.32 591.45c-169.25-169.4-394.32-262.73-634.15-262.83-494.13 0-896.28 402-896.48 896.14a894.32 894.32 0 0 0 119.66 448l-127.18 464.4 475.24-124.62a896.07 896.07 0 0 0 428.4 109.08h.37c494.07 0 896.27-402.05 896.47-896.18.09-239.46-93.07-464.63-262.33-634ZM1278.18 1970.3h-.31a744.11 744.11 0 0 1-379.24-103.83l-27.21-16.14-282 74 75.27-274.87-17.69-28.23a742.88 742.88 0 0 1-114-396.42C533.2 814.12 867.46 480 1278.47 480c199 .08 386.1 77.66 526.78 218.46s218.11 327.94 218 527c-.16 410.73-334.41 744.89-745.1 744.89Z"
          className="cls-2"
        />
        <path
          d="M977.6 1658.86c6.31 3.8 19.27 3.8 49 3.77 126.15-.11 235.11-.49 312.62-.49 361.71 0 352.2-380.79 183.08-428.3 24.77-43.88 137.63-126.32 67.83-296.72-69-168.49-365.85-130.25-568.86-130.15-75.12 0-63.88 55.51-63.5 141.81.62 136.69.11 506.67 0 666.61 0 32.42 9.79 37.4 19.83 43.47Zm156.51-139.55c34.15 0 114.71 0 183.77-.11 78.2-.12 147.83-36.7 146.09-114.55-1.27-73.33-50.06-97.4-117.78-104.12-64.5.62-138.27.62-212.08.62v218.16Zm0-365.44c136.05-1.87 188.54 5.48 262.82-13.12 51-29 73.34-136.42.29-172.92-50.75-25.35-200.71-16.68-263.11-14.08v200.12Z"
          className="cls-2"
        />
      </svg>
    </IconWrapper>
  )
}
